import { PRIVATE_API_ROUTES } from '@/constants/api.constants';
import { getFlatListApiCall } from './utils';

export const flatListFurtherEducationTitles = getFlatListApiCall({
  route: PRIVATE_API_ROUTES.furtherEducationTitles,
});
